import { render, staticRenderFns } from "./DepartmentPathIcon.vue?vue&type=template&id=257f7852"
import script from "./DepartmentPathIcon.vue?vue&type=script&lang=js"
export * from "./DepartmentPathIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports